import React from 'react';
import { IPage } from '../../../../interfaces/models/models/paginated-response.model';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import TableActions from '../../../../shared/table/table-actions';
import Button from '../../../../shared/button';
import Table from '../../../../shared/table';

const tableColumns = ['Invoice Number', 'Purchase Id', 'Partner', 'Quantity', 'Shipping Cost (Tax Included)', 'Price', 'Actions']

interface IPurchasesTable {
    rows: any;
    paginationData?: IPage;
    rowsLoading: boolean;
    onDownloadInvoice: (id: string) => void;
    onSeeDetails: (id: string) => void;
    onSendInvoice: (id: string) => void;
    onEditDetails: (partnerId: string) => void;
    setPaginationState: ({ pageNumber, pageSize }: IPaginationPayload) => void;
}

const InvoicesTable = ({
    rows,
    paginationData,
    rowsLoading,
    onDownloadInvoice,
    onEditDetails,
    onSendInvoice,
    setPaginationState,
    onSeeDetails
}: IPurchasesTable) => {
    return (
        <Table
            columns={tableColumns}
            paginationData={paginationData}
            setPaginationState={setPaginationState}
        >
            {rowsLoading ?
                <>
                    {[...Array(4)].map((x, i) => {
                        return (
                            <tr key={i}>
                                {[...Array(tableColumns?.length || 1)].map((x, j) => {
                                    return (
                                        <td key={j} className='td-1 !min-w-[100%] text-center py-5'><span></span></td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </>
                : <>
                    {rows?.length > 0 && rows?.map((row: any, idx: number) => {
                        const totalQuantity = (row?.purchaseInfo?.items && row?.purchaseInfo?.items?.length > 0) && row?.purchaseInfo?.items?.reduce((accumulator: any, currentValue: any) => accumulator + (currentValue?.qty), 0)
                        const totalShippingCosts = row?.invoiceInfo && row?.invoiceInfo?.shippingCosts + row.invoiceInfo?.shippingTaxAmount
                        return (
                            <tr key={idx} className='bg-white border-b hover:bg-gray-50'>
                                <td className='px-6 py-4'>{row?.invoiceNumber}</td>
                                <td className='px-6 py-4'>{row?.quoteId}</td>
                                <td className='px-6 py-4'>{row?.partner?.companyName || row?.partner?.username}</td>
                                <td className='px-6 py-4'>{totalQuantity || 0}</td>
                                <td className='px-6 py-4'>{Number(totalShippingCosts).toFixed(2)}</td>
                                <td className='px-6 py-4'>{Number(row?.invoiceInfo?.total).toFixed(2)}</td>
                                <td className='px-6 py-4 min-w-[120px]'>
                                    <div className='flex flex-row'>
                                        <div data-qa='purchase-details' onClick={() => (row?._id) && onSeeDetails(row?._id)}>
                                            <img title={'View Details'} alt='item details' src={'/assets/table-actions/visibility.svg'} className={'h-[14px] object-contain cursor-pointer mr-2'} />
                                        </div>
                                        <TableActions>
                                            {(!row?.invoiced) &&
                                                <>
                                                    <div
                                                        onClick={() => onEditDetails(row?._id)}
                                                        className='py-2 px-4 cursor-pointer flex flex-row items-center align-flex-start  hover:bg-[#f4f4f4]'
                                                        role='none'>
                                                        <Button
                                                            label={'Edit Invoice'}
                                                            dataQa={'edit-invoice'}
                                                            className={`btn-primary-text-underline !no-underline !font-normal !text-[#000] cursor-pointer`}
                                                        />
                                                    </div>
                                                    <div
                                                        onClick={() => onSendInvoice(row?._id)}
                                                        className='py-2 px-4 cursor-pointer flex flex-row items-center align-flex-start  hover:bg-[#f4f4f4]'
                                                        role='none'>
                                                        <Button
                                                            label={'Send Invoice'}
                                                            dataQa={'send-invoice'}
                                                            className={`btn-primary-text-underline !no-underline !font-normal cursor-pointer`}
                                                        />
                                                    </div>
                                                </>
                                            }
                                            {row?.pdfLink &&
                                                <div
                                                    onClick={() => onDownloadInvoice(row?.pdfLink)}
                                                    className='py-2 px-4 cursor-pointer flex flex-row items-center align-flex-start  hover:bg-[#f4f4f4]'
                                                    role='none'>
                                                    <Button
                                                        label={'Download Invoice'}
                                                        dataQa={'download-invoice'}
                                                        className={`btn-primary-text-underline !no-underline !font-normal cursor-pointer`}
                                                    />
                                                </div>
                                            }
                                        </TableActions>
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                </>
            }
        </Table>
    )
}

export default InvoicesTable;